import BootstrapVue from "bootstrap-vue";
import vClickOutside from "v-click-outside";
import Vue from "vue";
import VueCarousel from "vue-carousel";
import VueTheMask from "vue-the-mask";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import VCalendar from "v-calendar";
import "./assets/icomoon/style.css";
import "./assets/scss/app.scss";
import "./components";
import "./plugins";
import { init } from "./setup/api";

Vue.use(VCalendar, { componentPrefix: "v" });
Vue.use(BootstrapVue);
Vue.use(VueTheMask);
Vue.use(VueCarousel);
Vue.use(vClickOutside);

init();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
